import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { type LedgerAccountDetails } from '../../api-schema-types/financial/LedgerAccountDomainDtos'
import CONFIG from '../../app-configs'
import { ApiAuthStrategies } from '../shared/ApiAuthStrategies'

export const ledgerAccountApi = createApi({
  reducerPath: 'ledgerAccountApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${CONFIG.PROXIMA_BACK_END_V2_BASE_API_URL}/ledgers`,
    prepareHeaders: (headers: Headers, { getState }) => {
      const authToken = ApiAuthStrategies.getBearerTokenHeader()
      headers.set('authorization', authToken)
      return headers
    }
  }),

  endpoints: (builder) => ({
    getWallets: builder.query({
      query: ({ assetHolderId }) => ({
        url: `accounts/${assetHolderId}/wallets`,
        params: { }
      }),
      transformResponse: (response: LedgerAccountDetails[], meta: any, arg: any) => ledgerAccountMapper().walletMapper(response, meta, arg)
    }),

    getWalletTransactionSummaries: builder.query({
      query: ({ assetHolderId }) => ({
        url: `accounts/${assetHolderId}/wallets/transaction-summaries`,
        params: { }
      })
    })
  })
})

export const useLedgerGetWalletsQuery = ledgerAccountApi.endpoints.getWallets.useQuery
export const useLedgerGetWalletTransactionSummariesQuery = ledgerAccountApi.endpoints.getWalletTransactionSummaries.useQuery

// ====================================================================================================================

 
export const ledgerAccountMapper = () => {
  const walletMapper = (responseData: LedgerAccountDetails[], responseMeta: any, responseArgs: any): LedgerAccountDetails[] => {
    console.log(`[API] ledgerAccountMapper Loaded ${responseData.length} accounts`)
    return responseData
  }

  return {
    walletMapper
  }
}
